package com.lightningkite.kiteui.models

data class WindowStatistics(
    val width: Dimension,
    val height: Dimension,
    val density: Float,
)